export const getError = state => state.editCalibrationco2.get('error')
export const getIsSubmitting = state => state.editCalibrationco2.get('isSubmitting')
